import { type ReactElement } from 'react';

export const NotAvailable = ({ label = 'N/A' }: { readonly label?: string }): ReactElement => (
  <span className="tds-text-grey-350">{label}</span>
);
